<!--
 * @description 通用上传组件
 * @component Upload
 * @version 1.1.0
 * 
 * @功能说明
 * 1. 支持图片、视频、文件上传
 * 2. 支持多种上传类型（单图、多文件、视频、证书等）
 * 3. 支持自定义上传模块名称
 * 4. 支持自定义上传文件名（如：课程名称、课程名称+时间等）
 * 
 * @Props
 * @param {Number} type - 上传类型：1=图片, 2=文件, 3=p12证书, 4=视频/图片, 10=仅上传按钮, 默认 1
 * @param {String} url - 已有图片URL，用于回显
 * @param {String} size - 按钮尺寸：'default' | 'small', 默认 'default'
 * @param {Object} edata - 额外的上传数据
 * @param {String} uploadUrl - 上传接口类型：'image' | 'video' | 'file', 默认 'image'
 * @param {String} text - 上传按钮文字
 * @param {String} moduleName - 模块名称，用于标识上传来源
 * @param {String} customFileName - 自定义上传文件名，支持传入课程名称等
 * 
 * @Events
 * @event success - 上传成功回调，参数: { url, ... }
 * @event deleteVideo - 删除视频回调
 * 
 * @使用示例
 * 基础图片上传:
 * <Upload moduleName="课程" @success="handleSuccess" />
 * 
 * 自定义文件名上传（课程封面）:
 * <Upload 
 *   module-name="课程" 
 *   :custom-file-name="courseName"
 *   @success="handleSuccess" 
 * />
 * 
 * 自定义文件名上传（课程名称+时间）:
 * <Upload 
 *   module-name="课程" 
 *   :custom-file-name="courseName + '_' + new Date().getTime()"
 *   @success="handleSuccess" 
 * />
 -->
<template>
    <div class="upload-box">
        <div class="avatar-uploader" v-if="type == 10 && uploadUrl == 'image'" flex="main:center cross:center" :class="size">
            <div flex="dir:top">
                <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                    <div class="upload-btn" flex="cross:center main:center">
                        <span class="el-icon-plus"></span>
                    </div>
                </el-upload>
                <!-- <el-link @click="fileDialog = true">{{size != 'small' ? '图库' : ''}}选择</el-link> -->
            </div>
        </div>
        <div class="avatar-uploader" v-if="type == 1 && uploadUrl == 'image'" flex="main:center cross:center" :class="size">
            <div v-if="!image" flex="dir:top">
                <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                    <div class="upload-btn" flex="cross:center main:center">
                        <span class="el-icon-plus"></span>
                    </div>
                    <!-- <el-link>上传{{size != 'small' ? '图片' : ''}}</el-link> -->
                </el-upload>
                <!-- <el-link @click="fileDialog = true">{{size != 'small' ? '图库' : ''}}选择</el-link> -->
            </div>
            <div v-else>
                <CImage fit="contain" :url="image" width="120" height="120"></CImage>
                <div class="position-btns" flex="cross:center">
                    <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    class="flex-1"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload" flex="">
                        <a href="javascript:;" class="flex-1">重新上传</a>
                    </el-upload>
                    <!-- <span class="line"></span> -->
                    <!-- <a href="javascript:;" class="flex-1" @click="fileDialog = true">选择</a> -->
                </div>
            </div>
        </div>
        <div class="video-uploader" v-if="type == 1 && uploadUrl == 'video'">
            <div flex="cross:center">
                <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                <div>
                    <el-button type="primary">上传视频</el-button>
                </div>
                </el-upload>
                <!-- <el-button type="primary" @click="fileDialog = true">图库选择视频</el-button> -->
                <!-- <el-button type="danger" style="margin-left:0" v-if="image" @click="deleteVideo">删除视频</el-button> -->
            </div>
            <div class="video" v-if="image">
                <video controls :src="$util.img(image)"></video>
            </div>

        </div>

        <div v-if="type == 2" flex="">
            <el-upload
                :action="action"
                style="display: inline-block"
                :headers="headers"
                multiple
                :data="edata"
                name="upload"
                v-if="type == 2"
                :show-file-list="false"
                :on-success="fileSuccess"
                :before-upload="beforeUpload">
                <el-button v-if="type == 2" :size="size" type="primary">{{text?text:'点击上传'}}</el-button>
            </el-upload>
        </div>

        <el-upload
            :action="action"
            style="display: inline-block"
            :headers="headers"
            multiple
            :data="edata"
            name="upload"
            v-if="type == 3"
            :show-file-list="false"
            :on-success="fileSuccess"
            :before-upload="beforeUpload">
            <el-button v-if="type == 3">上传p12证书</el-button>
        </el-upload>

        <div class="avatar-uploader" v-if="type == 4" flex="main:center cross:center">
            <el-upload
                :action="action"
                style="display: inline-block"
                :headers="headers"
                :data="edata"
                name="upload"
                :show-file-list="false"
                :on-success="fileSuccess"
                :before-upload="beforeUpload">
                <div>
                    <video controls style="max-width: 120px;max-height: 120px;" v-if="image && (image.indexOf('.mp4') > 0 || image.indexOf('.avi') > 0)" :src="image" class="avatar" />
                    <img style="max-width: 120px;max-height: 120px;" v-else-if="image" :src="$util.img(image)" class="avatar" />
                    <i v-else style="font-size: 30px;" class="el-icon-plus avatar-uploader-icon"></i>
                </div>
            </el-upload>
            <div class="intro-text" v-if="type == 1 && image">点击更换</div>
        </div>

		<el-dialog title="从图库选择" :visible.sync="fileDialog" append-to-body>
            <FileList v-if="fileDialog" @success="fileSelectSuccess"></FileList>
		</el-dialog>
    </div>
</template>

<script>
import FileList from './FileList.vue'
export default {
    props: {
        type: {
            type: Number,
            default: 1,
        },
        url: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'default'
        },
        edata: {
            type: Object,
            default: null,
        },
        uploadUrl: {
            type: String,
            default: 'image'
        },
        text: {
            type: String,
            default: ''
        },
         moduleName: {
            type: String,
            default: ''
         },
         customFileName: {
            type: String,
            default: ''
         }
    },
    data(){
        return {
            action: '',
            headers: {},
            image: '',

            fileDialog: false,

            selectDialog: false,
        }
    },
    components: {
        FileList,
    },
    mounted() {
        this.init()
    },
    watch: {
        url(info){
            this.image = info
        }
    },
    methods: {
        init(){
            let url = this.$config.baseUrl + '/api/school/file/upload/' + this.uploadUrl + "?module=" + this.moduleName;
            if(this.customFileName){
                url += "&customFileName=" + encodeURIComponent(this.customFileName);
            }
            this.action = url;
            this.headers = {'Authorization': this.$util.cacheGet("authTokenSchool")};
            if(this.url){
                this.image = this.url;
            }
        },
        deleteVideo(){
            this.image = ''
            this.$emit('deleteVideo')
        },
        fileSuccess(res, file) {
            if(res.status == 1){
                this.image = res.data.url;
                this.selectDialog = false;
                this.$emit('success', res.data);
            }else{
                this.$message({
                    message: res.msg,
                    type: 'error'
                })
            }
        },
        fileSelectSuccess(row){
            this.image = row.url;
            this.fileDialog = false;
            this.selectDialog = false;
            this.$emit('success', {
                url: row.url
            })
        },
        beforeUpload(file){
            if(file.size > (50 * 1024 * 1024)){
                this.$message({
                    message: '文件大小不超过50M',
                    type: 'error'
                })
                return false
            }
        },
        toSelectFile(){
            this.fileDialog = true;
        }
    }
}
</script>

<style lang="scss" scoped>
    .upload-box{
        display: inline-block;
    }
    .avatar-uploader{
        width: 120px;
        height: 120px;
        border: 1px dashed #ccc;
        overflow: hidden;
        font-size: 0;
        cursor: pointer;
        position: relative;
        .upload-btn{
            width: 120px;
            height: 120px;
            span{
                height: 40px;
                font-size: 40px;
                color: #ccc;
            }
        }
        .position-btns{
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 10;
            width: 100%;
            background: rgba(0,0,0,0.7);
            height: 20px;
            a{
                color: #fff;
                text-decoration: none;
                text-align: center;
                font-size: 12px;
            }
            .line{
                width: 1px;
                background: rgba(255,255,255,0.4);
                height: 20px;
            }
        }
        .image{
            width: 120px;
            height: 120px;
        }
        .select-btns{
            position: absolute;
            left: 0;
            top: 0;
            width: 120px;
            height: 120px;
            background: rgba(0,0,0,0.4);
        }
        .intro-text{
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0,0,0,0.7);
            color: #fff;
            width: 100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            overflow: hidden;
            font-size: 12px;
        }
        &.small{
            width: 60px;
            height: 60px;
            .image{
                width: 60px;
                height: 60px;
            }
        }
    }
    
    .video-uploader{
        .video{
            padding-top: 20px;
            video{
                width: 300px;
                background: #000;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Upload.vue